import { styled } from "@linaria/react";
import React from "react";
import Color from "color";
import { color, stableColor } from "..";
import { fonts } from "../Theme";

interface P {
  name: string;
  login: string;
  className?: string;
}

const InitialStyled = styled.span<{
  backgroundColor: string;
  color: string;
}>`
  display: inline-block;
  font: ${fonts.body2};
  width: 1.6em;
  height: 1.6em;
  line-height: 1.6em;
  text-align: center;
  border-radius: 50%;
  background-color: ${props => props.backgroundColor};
  /* margin-right: 0.5em; */
  color: ${props => props.color};
  font-weight: 600;
  flex: none;
`;

const Initial = ({ name, login, className }: P) => {
  const backgroundColor = stableColor(login.toUpperCase());
  const _color = new Color(backgroundColor).isLight() ? color.carbon900 : color.hydrogen;
  const letter = name.charAt(0);

  return (
    <InitialStyled className={className} backgroundColor={backgroundColor} color={_color}>
      {letter}
    </InitialStyled>
  );
};

export default React.memo(Initial);
